import GamerInterface from 'interfaces/GamerInterface';
import defaultTeamPhoto from 'css-images/default-team-photo.svg';
import defaultGamerPhoto from 'css-images/default-gamer-photo.svg';

const getSrcOrDefaultPhoto = (
    imageDomain: string,
    gamer?: GamerInterface
): string => {
    const defaultPhoto = gamer?.is_player === false ? defaultTeamPhoto : defaultGamerPhoto;

    return gamer?.photo?.src
        ? `${imageDomain}${gamer.photo.src}`
        : defaultPhoto;
};

export default getSrcOrDefaultPhoto;
